// extracted by mini-css-extract-plugin
export var quantityInput = "_gb-0";